<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditSysDict" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="类型" prop="SysDict.type">
            <el-select class="input-item" v-model="formData.SysDict.type" :clearable="true" filterable disabled
              placeholder="类型" :loading="EditSysDict.type.impl.loading"
              @visible-change="EditSysDict.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in EditSysDict.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="编码" prop="SysDict.code">
            <el-input class="input-item" v-model="formData.SysDict.code"
              :clearable="true" placeholder="编码" type="textarea" autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="名称" prop="SysDict.name">
            <el-input class="input-item" v-model="formData.SysDict.name"
              :clearable="true" placeholder="名称" type="textarea" autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="内容" prop="SysDict.content">
            <el-input class="input-item" v-model="formData.SysDict.content"
              :clearable="true" placeholder="内容" type="textarea" autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="SysDict.remark">
            <el-input class="input-item" v-model="formData.SysDict.remark"
              :clearable="true" placeholder="备注" type="textarea" autosize
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="图标" prop="SysDict.icon">
            <el-input class="input-item" v-model="formData.SysDict.icon"
              :clearable="true" placeholder="图标"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="启用" prop="SysDict.enableFlag">
            <el-radio-group class="input-item" v-model="formData.SysDict.enableFlag"
              @change="onEnableFlagValueChange"
            >
              <el-radio v-for="item in EditSysDict.enableFlag.impl.dropdownList" :key="item.id"
                :label="item.id"
              >
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="排序" prop="SysDict.sort">
            <el-input-number class="input-item" v-model="formData.SysDict.sort"
              :clearable="true"
              placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditSysDict:EditSysDict:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { DictionaryController, SysDictController } from '@/api';

export default {
  name: 'EditSysDict',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      formData: {
        SysDict: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          name: undefined,
          content: undefined,
          enableFlag: undefined,
          remark: undefined,
          sort: undefined,
          icon: undefined,
          gcode: undefined,
          tid: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'SysDict.code': [
          {required: true, message: '请输入编码', trigger: 'blur'}
        ],
        'SysDict.type': [
          {required: true, message: '请输入类型', trigger: 'blur'}
        ],
        'SysDict.name': [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        'SysDict.sort': [
          {type: 'integer', message: '排序只允许输入整数', trigger: 'blur', transform: (value) => Number(value)}
        ],
        'SysDict.content': [
          {required: true, message: '请输入内容', trigger: 'blur'}
        ],
        'SysDict.enableFlag': [
          {type: 'string', pattern: rules.pattern.english, message: '启用只允许输入英文字符', trigger: 'blur'}
        ]
      },
      EditSysDict: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        enableFlag: {
          impl: new DropdownWidget(this.loadEnableFlagDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onSubmit (code) {
      this.$emit('submit', code);
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDictType(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 启用下拉数据获取函数
     */
    loadEnableFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 更新编辑字典
     */
    refreshEditSysDict (reloadData = false) {
      this.loadSysDictData().then(res => {
        if (!this.EditSysDict.isInit) {
          // 初始化下拉数据
          this.EditSysDict.enableFlag.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditSysDict.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditSysDict.validate((valid) => {
        if (!valid) return;
        let params = {
          sysDictDto: {
            id: this.id,
            enableFlag: this.formData.SysDict.enableFlag,
            pid: this.formData.SysDict.pid,
            type: this.formData.SysDict.type,
            code: this.formData.SysDict.code,
            name: this.formData.SysDict.name,
            content: this.formData.SysDict.content,
            remark: this.formData.SysDict.remark,
            sort: this.formData.SysDict.sort,
            icon: this.formData.SysDict.icon,
            gcode: this.formData.SysDict.gcode,
            tid: this.formData.SysDict.tid
          }
        };

        SysDictController.update(this, params).then(res => {
          this.$message.success('保存成功');
          this.refreshEditSysDict();
          this.onSubmit(true);
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEditSysDict(true);
    },
    /**
     * 获取系统字典详细信息
     */
    loadSysDictData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.SysDict.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          SysDictController.view(this, params).then(res => {
            this.formData.SysDict = {...res.data, isDatasourceInit: true};
            if (this.formData.SysDict.typeDictMap && this.EditSysDict.type.impl.dirty) {
              this.EditSysDict.type.impl.dropdownList = [this.formData.SysDict.typeDictMap];
            }
            this.EditSysDict.enableFlag.impl.onVisibleChange(true).catch(e => {});
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SysDict: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          name: undefined,
          content: undefined,
          enableFlag: undefined,
          remark: undefined,
          sort: undefined,
          icon: undefined,
          gcode: undefined,
          tid: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditSysDict();
    }
  },
  computed: {
    // 初始化组件数据所需输入参数
    initSysDictParamChange () {
      return {
        id: this.id
      }
    },
    // 监听输入参数变化，用于数据变化后重新获取数据，如果存在多个数据组件或者数据组件使用不同的输入参数的优化，请拆分这里的代码
    formInputParamChange () {
      return {
        id: this.id
      }
    }
  },
  watch: {
    // 初始化组件数据所需输入参数，如果有多个初始化数据源需要优化，请修改这里的代码，只重置和更新相应的数据源数据
    initSysDictParamChange: {
      handler (newValue) {
        this.resetFormData();
        this.refreshEditSysDict();
      },
      immediate: true
    },
    formInputParamChange: {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
